const isVisible = ref<boolean>(false);
const savedScrollY = ref<number>(0);

export function useCheckoutModal() {
  const showCheckout = (state?: boolean): void => {
    if (!import.meta.client) {
      return;
    }
    isVisible.value = typeof state === 'boolean' ? state : !isVisible.value;

    if (isVisible.value) {
      savedScrollY.value = globalThis.scrollY || document.documentElement.scrollTop || 0;
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden');
      globalThis.scrollTo({ top: savedScrollY.value || 0, left: 0, behavior: 'instant' });
    }
  };

  return {
    isVisible,
    showCheckout,
  };
}
